import Vue from 'vue';
import TombolaBaseComponent from '@/components/base/base.component';
import { Component, Prop } from 'vue-property-decorator';
import { getPathToCallImagesFolder } from '@/components/game/_domain';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { IGame, IGameRepresentationChangedArgs } from '@/components/game/_domain/models';

@Component({
  name: 'CallValueComponent'
})
export default class CallValueComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  @Prop() public callImageSize: string;
  private pathToCallImage: string = '';
  private callValue: number = null;
  private callsAsImages: boolean = false;


  private mounted() {
    const game = this.gameController.getGame();
    this.setSkin(game);

    Vue.nextTick(() => {
      this.gameController.onGameRepresentationChanged(this.handleGameRepresentationChanged);
    });
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation = eventArgs.currentGameRepresentation;

    if (gameRepresentation.callboard.initialCallValue || gameRepresentation.callboard.currentCallValue === null) {
      this.callValue = gameRepresentation.callboard.currentCallValue;
    } else {
      this.callValue = gameRepresentation.callboard.currentCallValue - 1;
    }
  }

  private setSkin(game: IGame) {
    const gameIdentity = game.gameIdentity;
    const gameConfig = game.gameConfiguration;
    this.callsAsImages = gameConfig.showCallsAsImages;
    this.pathToCallImage = getPathToCallImagesFolder(gameIdentity.name, gameIdentity.clubName, gameConfig.callSkins);
  }

  private getPathToPlaceholderCallImage(): string {
    const game = this.gameController.getGame();
    const gameIdentity = game.gameIdentity;
    const gameName = gameIdentity.nameForConfiguration;
    return `/static/games/${gameName}/skins/placeholder.png`;
  }

  private renderCallImage() {
    if (!this.callValue) {
      return this.getPathToPlaceholderCallImage();
    }
    return `${this.pathToCallImage}${this.callValue}.png`;
  }

  private get callValueName(): string {
    const game = this.gameController.getGame();
    return game.gameConfiguration.callNames[this.callValue - 1];
  }

  public get callImageSizeClass(): string {
    const baseName = 'call-value-image';
    if (this.callImageSize === 'lg') {
      return baseName + '-lg';
    }

    return baseName;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/_default/_components/call-value/call-value.component.ts